var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "28px",
    height: "28px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9583333333333334s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(15 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.875s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7916666666666666s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(75 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7083333333333334s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(105 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.625s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5416666666666666s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(165 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4583333333333333s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(195 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.375s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.2916666666666667s",
    repeatCount: "indefinite"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(255 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.20833333333333334s",
    repeatCount: "indefinite"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(285 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.125s",
    repeatCount: "indefinite"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.041666666666666664s",
    repeatCount: "indefinite"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(345 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    rx: 4,
    ry: 7,
    width: 8,
    height: 14,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerBlue);
export default __webpack_public_path__ + "static/media/spinner_blue.9e9d21761deb8650b6e8675b9602e257.svg";
export { ForwardRef as ReactComponent };